const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ==========================================================
   LNGVTY: show the selected size in the URL on product pages
   Works with the custom PDP hero (sections/new-pdp.liquid).
   URL format: /products/<handle>?variant=<id>&size=30ml
   - updates the URL when a size button is tapped
   - adds the size to the URL on page load
   - links with only ?size=10ml open with that size selected
   - keeps utm_*, fbclid and other params intact
========================================================== */
(function () {
  if (!/\/products\//.test(window.location.pathname)) return;

  var SELECTOR = '.lngvty-hero__variant[data-variant-id]';

  function sizeSlug(title) {
    if (!title || title === 'Default Title') return null;
    return String(title)
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/\+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  function setUrl(variantId, title) {
    var current = new URLSearchParams(window.location.search);
    var next = new URLSearchParams();
    if (variantId) next.set('variant', variantId);
    var size = sizeSlug(title);
    if (size) next.set('size', size);
    current.forEach(function (value, key) {
      if (key !== 'variant' && key !== 'size') next.append(key, value);
    });
    var query = next.toString();
    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname + (query ? '?' + query : '') + window.location.hash
    );
  }

  function init() {
    var buttons = document.querySelectorAll(SELECTOR);
    if (!buttons.length) return;

    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
      if (button) setUrl(button.dataset.variantId, button.dataset.title);
    });

    var params = new URLSearchParams(window.location.search);
    var requestedSize = params.get('size');

    if (requestedSize && !params.get('variant')) {
      for (var i = 0; i < buttons.length; i++) {
        if (sizeSlug(buttons[i].dataset.title) === requestedSize) {
          buttons[i].click();
          return;
        }
      }
    }

    var active = document.querySelector(SELECTOR + '[aria-pressed="true"]');
    if (active) setUrl(active.dataset.variantId, active.dataset.title);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
